export default "__VITE_ASSET__CDFxLe_Y__"